/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type waitTillAuthPopupIsClosedLocal = {
    readonly authPopup: {
        readonly open: boolean;
    };
    readonly " $refType": "waitTillAuthPopupIsClosedLocal";
};
export type waitTillAuthPopupIsClosedLocal$data = waitTillAuthPopupIsClosedLocal;
export type waitTillAuthPopupIsClosedLocal$key = {
    readonly " $data"?: waitTillAuthPopupIsClosedLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"waitTillAuthPopupIsClosedLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "waitTillAuthPopupIsClosedLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthPopup",
                    "kind": "LinkedField",
                    "name": "authPopup",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "open",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '0b929045db7f1bc1dcfe8e06dde57d21';
export default node;
